export default __webpack_public_path__ + "static/1-froggy-b65a8a15236c474e9c73f1f451e64bb5.jpeg";